import { compose } from 'recompose';

import LoaderView from './LoaderView';

export default compose()(LoaderView);
